(function () {
    'use strict';

    // Cache for storing requests (both pending and resolved)
    let requestsCache = {};

    // Hierarchy order constant
    const HIERARCHY_ORDER = ['Primary', 'Secondary', 'Tertiary', 'Other', 'none'];
    const PENDING_HIERARCHY_ORDER = ['Primary', 'Secondary', 'Tertiary', 'Last', 'Other', 'none'];

    angular
        .module('elogbooksDirectives')
        .factory('elogsSelectSiteAssociationDirectiveFactory', function ($uibModal, apiClient, lodash, $q, messenger, $translate, $rootScope, $timeout) {
            $rootScope.$on('$stateChangeStart', () => requestsCache = {});

            return function createSiteAssociationDirective(config = {}) {
                const directiveConfig = angular.merge({
                    templateUrl: '/modules/directives/form-elements/select-site-associate/select-site-associate.html',
                    inactiveUserMessageKey: 'ASSOCIATE_USER_INACTIVE'
                }, config);

                return {
                    restrict: 'A',
                    templateUrl: directiveConfig.templateUrl,
                    scope: {
                        model: '=ngModel',
                        widgetIndex: '@?'
                    },
                    require: ['ngModel', 'elogbooksSelectMultipleHtmlOptions'],
                    controller: ['$scope', function($scope) {
                        // Variables for managing watchers and state
                        let deregisterUpdate;
                        let advFilters = {};
                        let allSitesSaved;
                        let loadedSelectedSitesSaved;
                        let allSitesUnsavedIds = new Set();
                        let pendingRemovedOptionsByHref = new Map();
                        let initialLoadTimeout;
                        let selectedSitesRequestVersion = 0;

                        // Initialize models and state
                        initializeModels();

                        // Set up scope functions
                        $scope.add = addAction;
                        $scope.remove = removeAction;

                        // Set up watchers
                        setupWatchers();

                        $scope.$on('$destroy', function() {
                            initialLoadTimeout && $timeout.cancel(initialLoadTimeout);
                        });

                        function initializeModels() {
                            const defaultModel = {
                                link: null,
                                loading: $scope.model?.loading || false,
                                responseKeyPath: 'data',
                                itemHrefPath: '_links.self.href',
                                itemValuePath: 'name',
                                selectedLink: null,
                                selectedResponse: null,
                                selectedRequestParams: {},
                                selectedLimit: 30,
                                requestParams: {},
                                keyword: null,
                                expandedSearch: false,
                                required: false,
                                disabled: false,
                                selectedItems: [],
                                map: map,
                                getResponseData: getResponseData,
                                filterResponse: filterResponse,
                                clear: clearAction,
                                discardChanges: discardChanges,
                                expandSearch: expandSearchAction,
                                updateSelectedOptions: updateSelectedOptions,
                                clearField: clearField,
                                isUserInactive: $scope.model?.isUserInactive || false,
                                isChanged: false,
                                internalState: null,
                            };

                            $scope.hierarchySelectModel = {
                                type: 'options',
                                value: "none",
                                invalid: false,
                                options: [
                                    {value: 'none', label: $translate.instant('SELECT_HIERARCHY')},
                                    {value: 'Primary', label: $translate.instant('HIERARCHY_PRIMARY')},
                                    {value: 'Secondary', label: $translate.instant('HIERARCHY_SECONDARY')},
                                    {value: 'Tertiary', label: $translate.instant('HIERARCHY_TERTIARY')},
                                    {value: 'Last', label: $translate.instant('HIERARCHY_LAST')},
                                ]
                            };

                            const shouldLoadAllSitesOnInit = !$scope.model?.response
                                && !!$scope.model?.link
                                && !!Object.keys($scope.model?.requestParams || {}).length;
                            const shouldLoadSelectedSitesOnInit = !$scope.model?.selectedResponse && !!$scope.model?.selectedLink;
                            const initialAllSitesLoadingState = $scope.model?.loading || shouldLoadAllSitesOnInit;
                            const initialSelectedSitesLoadingState = $scope.model?.loading || shouldLoadSelectedSitesOnInit;

                            $scope.allSitesModel = {
                                invalid: false,
                                isLoading: initialAllSitesLoadingState,
                                selected: [],
                                options: [],
                                hasMoreOptions: false,
                                loadNext: () => $q.resolve()
                            };

                            $scope.selectSitesModel = {
                                invalid: false,
                                isLoading: initialSelectedSitesLoadingState,
                                selected: [],
                                options: filterSelectedOptions($scope.model?.selectedItems || []),
                                hasMoreOptions: false,
                                loadNext: $scope.model?.selectedLink ? loadNextSelectedSitesPage : null
                            };

                            $scope.selectedSitesFilteringKeyword = null;

                            $scope.model = lodash.merge(defaultModel, $scope.model || {});
                            angular.extend($scope.model, {
                                map,
                                getResponseData,
                                filterResponse,
                                clear: clearAction,
                                discardChanges,
                                expandSearch: expandSearchAction,
                                updateSelectedOptions,
                                clearField
                            });
                            $scope.suppressKeywordWatch = false;
                        }

                        if ($scope.model.response) {
                            $scope.allSitesModel.options = lodash.differenceBy(
                                $scope.model.filterResponse($scope.model.response),
                                $scope.model.selectedItems,
                                'href'
                            );
                        }

                        restoreInternalState();

                        function setupWatchers() {
                            $scope.$watch('model.keyword', lodash.debounce((newVal, oldVal) => {
                                if (!$scope.suppressKeywordWatch && newVal !== null && oldVal !== null) {
                                    extendedSearchAction({
                                        name: newVal
                                    });
                                }
                            }, 500));

                            $scope.$watch('selectedSitesFilteringKeyword', lodash.debounce((newVal, oldVal) => {
                                if (newVal !== oldVal) {
                                    selectedSitesFilteringAction(newVal);
                                }
                            }, 500));

                            $scope.$watch('model.loading', (isLoading) => {
                                $scope.allSitesModel.isLoading = !!isLoading;
                                $scope.selectSitesModel.isLoading = !!isLoading;
                            }, true);

                            if (!isSelectedSitesPaginated()) {
                                deregisterUpdate = $scope.$watch('selectSitesModel.options', (options) => $scope.model.selectedItems = options);
                            }
                        }

                        function registerUpdate() {
                            if (isSelectedSitesPaginated()) {
                                return;
                            }

                            if (deregisterUpdate) {
                                deregisterUpdate();
                            }

                            deregisterUpdate = $scope.$watch('selectSitesModel.options', (options) => $scope.model.selectedItems = options);
                        }

                        function isSelectedSitesPaginated() {
                            return !!$scope.model.selectedLink;
                        }

                        function invalidateSelectedSitesRequests() {
                            selectedSitesRequestVersion++;

                            return selectedSitesRequestVersion;
                        }

                        function getSelectedSitesRequestVersion() {
                            return selectedSitesRequestVersion;
                        }

                        function isSelectedSitesRequestCurrent(requestVersion) {
                            return requestVersion === selectedSitesRequestVersion;
                        }

                        function persistInternalState() {
                            $scope.model.internalState = {
                                allSitesSaved: angular.copy(allSitesSaved || []),
                                loadedSelectedSitesSaved: angular.copy(loadedSelectedSitesSaved || []),
                                allSitesUnsavedIds: Array.from(allSitesUnsavedIds),
                                pendingRemovedOptions: getPendingRemovedOptions()
                            };
                        }

                        function restoreInternalState() {
                            const internalState = $scope.model.internalState || {};

                            allSitesSaved = angular.copy(internalState.allSitesSaved || $scope.allSitesModel.options);
                            loadedSelectedSitesSaved = angular.copy(
                                internalState.loadedSelectedSitesSaved || $scope.selectSitesModel.options
                            );
                            allSitesUnsavedIds = new Set(internalState.allSitesUnsavedIds || []);
                            pendingRemovedOptionsByHref = new Map();

                            (internalState.pendingRemovedOptions || []).forEach(addPendingRemovedOption);
                            $scope.allSitesModel.options = mergePendingRemovedOptions($scope.allSitesModel.options);
                            setUnsavedStyle($scope.allSitesModel.options, allSitesUnsavedIds);
                        }

                        function removeAction () {
                            if ($scope.selectSitesModel.selected.length === 0) {
                                $scope.selectSitesModel.invalid = true;
                                messenger.error('PLEASE_SELECT_SITE');
                                return;
                            } else {
                                $scope.selectSitesModel.invalid = false;
                            }

                            $scope.hierarchySelectModel.invalid = false;
                            $scope.hierarchySelectModel.value = 'none';

                            const selectedSites = filterSelectedOptions($scope.selectSitesModel.selected, 'none');
                            const allSitesOptions = filterSelectedOptions($scope.allSitesModel.options, 'none');

                            for (const site of selectedSites) {
                                site.optionContainerStyle = '';
                                const exists = isSelectedSitesPaginated()
                                    ? loadedSelectedSitesSaved.some((savedSelectedSite) => savedSelectedSite.id === site.id)
                                    : allSitesSaved.some((savedAllSite) => savedAllSite.id === site.id);
                                const isPendingRemoval = isSelectedSitesPaginated() ? exists : !exists;

                                if (isPendingRemoval) {
                                    $scope.model.isChanged = true;
                                    allSitesUnsavedIds.add(site.id);
                                    addPendingRemovedOption(site);
                                }
                            }

                            setUnsavedStyle(selectedSites, allSitesUnsavedIds);

                            $scope.allSitesModel.options = mergePendingRemovedOptions([...allSitesOptions, ...selectedSites]);
                            $scope.selectSitesModel.options = removeSelectedOptions($scope.selectSitesModel.options, selectedSites);

                            if (isSelectedSitesPaginated()) {
                                $scope.model.selectedItems = removeSelectedOptions($scope.model.selectedItems, selectedSites);
                            }

                            if (!allSitesUnsavedIds.size) {
                                $scope.model.isChanged = false;

                                for (const option of $scope.selectSitesModel.options) {
                                    if (option.optionContainerStyle.indexOf('unsaved') >= 0) {
                                        $scope.model.isChanged = true;
                                        break;
                                    }
                                }

                                persistInternalState();
                                return;
                            }

                            persistInternalState();
                            selectedSitesFilteringAction($scope.selectedSitesFilteringKeyword);
                        }

                        function addAction () {
                            if ($scope.allSitesModel.selected.length === 0) {
                                $scope.allSitesModel.invalid = true;
                                messenger.error('PLEASE_SELECT_SITE');
                                return;
                            } else {
                                $scope.allSitesModel.invalid = false;
                            }

                            const hierarchy = $scope.hierarchySelectModel.value;

                            if (!hierarchy || hierarchy === 'none') {
                                $scope.hierarchySelectModel.invalid = true;
                                messenger.error('PLEASE_SELECT_HIERARCHY');
                                return;
                            } else {
                                $scope.hierarchySelectModel.invalid = false;
                            }

                            const allSitesOptionsSelected = filterSelectedOptions($scope.allSitesModel.selected, hierarchy);

                            // Snapshot mutable state before we begin mutating, so we can roll back
                            // if the inactive-user guard fires and nothing ends up being added.
                            const allSitesUnsavedIdsBefore = new Set(allSitesUnsavedIds);
                            const pendingRemovedOptionsByHrefBefore = new Map(pendingRemovedOptionsByHref);

                            allSitesOptionsSelected.forEach(option => allSitesUnsavedIds.delete(option.id));
                            removePendingRemovedOptions(allSitesOptionsSelected);

                            applyUnsavedOptionStyle(allSitesOptionsSelected, loadedSelectedSitesSaved);

                            if ($scope.model.isUserInactive) {
                                for (const option of allSitesOptionsSelected) {
                                    let optionContainerStyle = option.optionContainerStyle.replace(' ', '');
                                    if (optionContainerStyle === 'unsaved') {
                                        // Roll back all mutations so isChanged is not left dirty
                                        // when no site was actually added to the selected list.
                                        allSitesUnsavedIds = allSitesUnsavedIdsBefore;
                                        pendingRemovedOptionsByHref = pendingRemovedOptionsByHrefBefore;
                                        allSitesOptionsSelected.forEach(opt => {
                                            opt.optionContainerStyle = (opt.optionContainerStyle || '')
                                                .replace('unsaved', '')
                                                .trim();
                                        });
                                        $scope.model.isChanged = allSitesUnsavedIds.size > 0 ||
                                            $scope.selectSitesModel.options.some(
                                                opt => (opt.optionContainerStyle || '').indexOf('unsaved') >= 0
                                            );
                                        messenger.error(directiveConfig.inactiveUserMessageKey);
                                        return;
                                    }
                                }
                            }

                            $scope.allSitesModel.options = $scope.allSitesModel.options.filter(option => {
                                for (const selectedItem of $scope.allSitesModel.selected) {
                                    if (selectedItem.id === option.id) {
                                        return false;
                                    }
                                }
                                return true;
                            });

                            const newSelectedOptions = [...$scope.selectSitesModel.options];

                            for (const siteToAdd of allSitesOptionsSelected) {
                                let isDuplicate = false;
                                for (const existingOption of newSelectedOptions) {
                                    if (existingOption.id === siteToAdd.id && existingOption.hierarchy === siteToAdd.hierarchy) {
                                        isDuplicate = true;
                                        break;
                                    }
                                }
                                if (!isDuplicate) {
                                    newSelectedOptions.push(siteToAdd);
                                }
                            }

                            $scope.selectSitesModel.options = orderSelectedOptionsWithPending(newSelectedOptions);

                            if (isSelectedSitesPaginated()) {
                                const addedSiteHrefs = new Set(allSitesOptionsSelected.map(option => option.href));

                                $scope.model.selectedItems = lodash.unionBy(
                                    allSitesOptionsSelected,
                                    ($scope.model.selectedItems || []).filter(option => !addedSiteHrefs.has(option.href)),
                                    'href'
                                );
                            }

                            persistInternalState();
                            selectedSitesFilteringAction($scope.selectedSitesFilteringKeyword);
                        }

                        function map(keyPath, valuePath, hierarchy) {
                            return function (item) {
                                if (typeof item === 'undefined'){
                                    return;
                                }

                                return  {
                                    id:  lodash.get(item, 'id'),
                                    href:  lodash.get(item, keyPath),
                                    value: lodash.get(item, valuePath),
                                    optionContainerStyle: lodash.get(item, 'optionContainerStyle', ''),
                                    hidden: lodash.get(item, 'hidden', false),
                                    hasAccess: lodash.get(item, 'hasAccess', false),
                                    hierarchy: hierarchy
                                        || lodash.get(item, 'hierarchy')
                                        || lodash.get(item, 'prefix')
                                        || lodash.get(item, 'associateHierarchyPrefix', 'none')
                                };
                            }
                        }

                        function getResponseData(response) {
                            return lodash.get(response.getData(), this.responseKeyPath);
                        }

                        function setUnsavedStyle(options, optionsIds) {
                            if (!optionsIds.size) {
                                return;
                            }

                            return options.map(option => {
                                if (optionsIds.has(option.id)) {
                                    if (option.optionContainerStyle.indexOf('unsaved') < 0) {
                                        option.optionContainerStyle += ' unsaved';
                                    }

                                    $scope.model.isChanged = true;
                                }
                            });
                        }

                        function addPendingRemovedOption(option) {
                            pendingRemovedOptionsByHref.set(option.href, option);
                        }

                        function removePendingRemovedOptions(options) {
                            options.forEach(option => pendingRemovedOptionsByHref.delete(option.href));
                        }

                        function mergePendingRemovedOptions(options) {
                            const pendingOptions = getVisiblePendingRemovedOptions();
                            const pendingOptionHrefs = new Set(pendingOptions.map(option => option.href));
                            const unchangedOptions = (options || []).filter(option => !pendingOptionHrefs.has(option.href));

                            return [
                                ...filterSelectedOptions(pendingOptions, 'none').sort((a, b) => a.value.localeCompare(b.value)),
                                ...filterSelectedOptions(unchangedOptions)
                            ];
                        }

                        function getPendingRemovedOptions() {
                            return Array.from(pendingRemovedOptionsByHref.values());
                        }

                        function getVisiblePendingRemovedOptions() {
                            const keyword = ($scope.model.keyword || '').toLowerCase();

                            if (!keyword) {
                                return getPendingRemovedOptions();
                            }

                            return getPendingRemovedOptions().filter((option) => {
                                return option.value && option.value.toLowerCase().indexOf(keyword) >= 0;
                            });
                        }

                        function applyUnsavedOptionStyle(options, savedOptions) {
                            $scope.model.isChanged = allSitesUnsavedIds.size > 0;

                            return options.map(option => {
                                let isUnsaved = true;
                                for (const savedOption of savedOptions) {
                                    if ((savedOption.id === option.id) && (savedOption.hierarchy === option.hierarchy)) {
                                        isUnsaved = false;
                                        break;
                                    }
                                }

                                if (isUnsaved) {
                                    if (option.optionContainerStyle.indexOf('unsaved') < 0) {
                                        option.optionContainerStyle += ' unsaved';
                                    }

                                    $scope.model.isChanged = true;
                                } else {
                                    option.optionContainerStyle = option.optionContainerStyle.replace('unsaved', '');
                                    $scope.model.isChanged = false;
                                }
                            });
                        }

                        function cleanOption(option) {
                            const clean = angular.copy(option);
                            clean.selected = false;
                            clean.hidden = false;
                            clean.optionContainerStyle = (clean.optionContainerStyle || '').replace('unsaved', '').trim();

                            return clean;
                        }

                        function discardChanges() {
                            invalidateSelectedSitesRequests();
                            allSitesUnsavedIds = new Set();
                            pendingRemovedOptionsByHref = new Map();
                            $scope.selectedSitesFilteringKeyword = null;

                            const selectedOptions = filterSelectedOptions((loadedSelectedSitesSaved || []).map(cleanOption));
                            const allOptions = $scope.model.response
                                ? removeSelectedOptions($scope.model.filterResponse($scope.model.response), selectedOptions)
                                : allSitesSaved || [];

                            $scope.selectSitesModel.options = selectedOptions;
                            $scope.model.selectedItems = selectedOptions;
                            $scope.allSitesModel.options = filterSelectedOptions(allOptions.map(cleanOption));

                            $scope.allSitesModel.selected = [];
                            $scope.selectSitesModel.selected = [];
                            $scope.selectSitesModel.isLoading = false;
                            $scope.hierarchySelectModel.invalid = false;
                            $scope.hierarchySelectModel.value = 'none';
                            $scope.model.isChanged = false;
                            persistInternalState();

                            return $q.resolve();
                        }

                        function filterResponse(response) {
                            return this.getResponseData(response).map(
                                this.map(this.itemHrefPath, this.itemValuePath)
                            );
                        }

                        const removeSelectedOptions = (options, selected) => {
                            if (!options || !selected || !selected.length) {
                                return filterSelectedOptions(options);
                            }

                            const selectedIds = new Set(selected.map(item => item.id));
                            const filteredOptions = options.filter(option => !selectedIds.has(option.id));

                            return filterSelectedOptions(filteredOptions);
                        };

                        function filterSelectedOptions(options, hierarchy = undefined) {
                            if (!options || !options.length) {
                                return [];
                            }

                            const filteredOptions = options.map(map('href', 'value', hierarchy));

                            return filteredOptions.sort((a, b) => {
                                const hierarchyA = HIERARCHY_ORDER.indexOf(a.hierarchy || 'none');
                                const hierarchyB = HIERARCHY_ORDER.indexOf(b.hierarchy || 'none');

                                if (hierarchyA !== hierarchyB) {
                                    return hierarchyA - hierarchyB;
                                }

                                return a.value.localeCompare(b.value);
                            });
                        }

                        function orderSelectedOptionsWithPending(options) {
                            const mappedOptions = filterSelectedOptions(options);
                            const pendingOptions = mappedOptions.filter((option) => {
                                const isUnsaved = option.optionContainerStyle && option.optionContainerStyle.indexOf('unsaved') >= 0;

                                return isUnsaved && !allSitesUnsavedIds.has(option.id);
                            }).sort((a, b) => {
                                const hierarchyA = PENDING_HIERARCHY_ORDER.indexOf(a.hierarchy || 'none');
                                const hierarchyB = PENDING_HIERARCHY_ORDER.indexOf(b.hierarchy || 'none');

                                if (hierarchyA !== hierarchyB) {
                                    return hierarchyA - hierarchyB;
                                }

                                return a.value.localeCompare(b.value);
                            });
                            const pendingOptionHrefs = new Set(pendingOptions.map(option => option.href));
                            const unchangedOptions = mappedOptions.filter(option => !pendingOptionHrefs.has(option.href));

                            return [
                                ...pendingOptions,
                                ...unchangedOptions
                            ];
                        }

                        function clearAction() {
                            advFilters = {};
                            setKeyword('');
                            return extendedSearchAction({});
                        }

                        function setKeyword(value, suppressWatch = false) {
                            $scope.suppressKeywordWatch = suppressWatch;
                            $scope.model.keyword = value;
                        }

                        function processApiResponse(response, options = null) {
                            if (response) {
                                if (!options) {
                                    options = removeSelectedOptions(
                                        $scope.model.filterResponse(response),
                                        $scope.model.selectedItems
                                    );
                                }

                                if (angular.isUndefined($scope.model.response) || response.page === 1) {
                                    allSitesSaved = options;
                                    setUnsavedStyle(options, allSitesUnsavedIds);
                                    $scope.allSitesModel.options = mergePendingRemovedOptions(options);
                                    persistInternalState();
                                }

                                $scope.model.response = response;
                                $scope.allSitesModel.loadNext = createLoadNextFunction(response);
                                return response;
                            }
                        }

                        function createSearchFilter(data) {
                            const filter = {
                                'siteRegions[]': data?.regionSelect?.selected ?
                                    [data.regionSelect.selected.object.id] : null,
                                'sectors[]': data?.sectorSelect?.selected ?
                                    [data.sectorSelect.selected.object.id] : null,
                                'siteGroups[]': typeof data?.siteGroupSelect?.selected !== 'undefined' ?
                                    [data.siteGroupSelect.selected.object.id] : null,
                                coreClient: typeof data?.coreClientSelect?.selected !== 'undefined' ?
                                    data.coreClientSelect.selected.object.id : null,
                                siteName: data?.name,
                                reference: data?.reference
                            };

                            const isEmpty = Object.keys(filter)
                                .every(key => [null, undefined, ''].includes(filter[key]));

                            return {
                                ...$scope.model.requestParams,
                                ...filter,
                                isEmpty
                            };
                        }

                        function updateAdvFilters(data) {
                            advFilters.name = data.name;
                            advFilters.reference = data.reference;
                            advFilters.siteRegion = data.regionSelect?.selected;
                            advFilters.sector = data.sectorSelect?.selected;
                            advFilters.siteGroup = data.siteGroupSelect?.selected;
                            advFilters.coreClient = data.coreClientSelect?.selected;
                        }

                        function extendedSearchAction(data) {
                            data = {...advFilterPayload(), ...data};
                            $scope.allSitesModel.isLoading = true;

                            const searchFilter = createSearchFilter(data);
                            setKeyword(data.name, true);

                            const processResponse = (response) => {
                                if (response) {
                                    const options = removeSelectedOptions(
                                        $scope.model.filterResponse(response),
                                        $scope.model.selectedItems
                                    );

                                    processApiResponse(response, options);
                                }

                                $scope.allSitesModel.selected = [];
                                $scope.allSitesModel.isLoading = false;
                                $scope.suppressKeywordWatch = false;

                                return response;
                            };

                            const cacheKey = $scope.model.link + JSON.stringify(searchFilter);

                            if (searchFilter.isEmpty) {
                                if (requestsCache[cacheKey]) {
                                    return requestsCache[cacheKey].then(response => processResponse(response));
                                }

                                requestsCache[cacheKey] = apiClient.get($scope.model.link, searchFilter);

                                return requestsCache[cacheKey]
                                    .then(function (response) {
                                        requestsCache[cacheKey] = $q.resolve(response);
                                        updateAdvFilters(data);
                                        return processResponse(response);
                                    })
                                    .catch((error) => {
                                        $scope.allSitesModel.isLoading = false;
                                        $scope.suppressKeywordWatch = false;
                                        delete requestsCache[cacheKey];
                                        throw error;
                                    });
                            }

                            return apiClient.get($scope.model.link, searchFilter)
                                .then(function (response) {
                                    updateAdvFilters(data);
                                    return processResponse(response);
                                })
                                .catch((error) => {
                                    $scope.allSitesModel.isLoading = false;
                                    $scope.suppressKeywordWatch = false;
                                    throw error;
                                });
                        }

                        function expandSearchAction() {
                            const modalInstance = $uibModal.open({
                                templateUrl: '/modules/common/modals/site-search-filters/select-site-modal-filters.html',
                                controller: 'SiteSearchFiltersModalController',
                                controllerAs: 'vm',
                                resolve : {
                                    filters: advFilters,
                                    restrictOne : false
                                }
                            });

                            modalInstance.result.then(extendedSearchAction, () => {});
                        }

                        function selectedSitesFilteringAction(keyword) {
                            if ($scope.model.selectedLink) {
                                return loadSelectedSites(keyword);
                            }

                            if (!$scope.selectSitesModel.options) {
                                return;
                            }

                            if (!keyword) {
                                $scope.selectSitesModel.options = orderSelectedOptionsWithPending($scope.selectSitesModel.options.map((option) => {
                                    option.hidden = false;
                                    option.optionContainerStyle = option.optionContainerStyle.replace('hidden', '');
                                    return option;
                                }));

                                return;
                            }

                            $scope.selectSitesModel.options = orderSelectedOptionsWithPending($scope.selectSitesModel.options.map((option) => {
                                if (option.value.toLowerCase().indexOf(keyword.toLowerCase()) < 0) {
                                    option.hidden = true;

                                    if (option.optionContainerStyle.indexOf('hidden') < 0) {
                                        option.optionContainerStyle += ' hidden';
                                    }
                                } else {
                                    option.hidden = false;
                                    option.optionContainerStyle = option.optionContainerStyle.replace('hidden', '');
                                }
                                return option;
                            }));
                        }

                        function createSelectedSitesFilter(keyword) {
                            const filter = {
                                ...$scope.model.selectedRequestParams,
                                datagroup: 'list',
                                limit: $scope.model.selectedLimit
                            };

                            if (keyword) {
                                filter.siteName = keyword;
                            }

                            return filter;
                        }

                        function processSelectedSitesResponse(response, append = false) {
                            const options = filterSelectedOptions($scope.model.filterResponse(response))
                                .filter(option => !allSitesUnsavedIds.has(option.id));
                            const pendingOptions = getPendingSelectedOptions($scope.selectedSitesFilteringKeyword);
                            const pendingOptionHrefs = new Set(pendingOptions.map(option => option.href));
                            const newOptions = append
                                ? lodash.differenceBy(options, $scope.selectSitesModel.options, 'href')
                                : options;

                            const visibleOptions = append
                                ? [...pendingOptions, ...$scope.selectSitesModel.options, ...newOptions]
                                : [...pendingOptions, ...newOptions.filter(option => !pendingOptionHrefs.has(option.href))];

                            $scope.selectSitesModel.options = orderSelectedOptionsWithPending(lodash.unionBy(visibleOptions, 'href'));

                            updateSelectedItemsState(options);

                            if (typeof $scope.model.onSelectedItemsLoaded === 'function') {
                                $scope.model.onSelectedItemsLoaded(options);
                            }

                            $scope.allSitesModel.options = mergePendingRemovedOptions(removeSelectedOptions(
                                $scope.allSitesModel.options,
                                $scope.model.selectedItems
                            ));

                            const hasNextLink = !!response.getLink('next');
                            $scope.selectSitesModel.hasMoreOptions = (response.page < response.pages) && hasNextLink;
                            $scope.model.selectedResponse = response;
                            loadedSelectedSitesSaved = lodash.unionBy(loadedSelectedSitesSaved || [], options, 'href');
                            persistInternalState();

                            return response;
                        }

                        function updateSelectedItemsState(options) {
                            $scope.model.selectedItems = lodash.unionBy(
                                $scope.model.selectedItems || [],
                                options,
                                'href'
                            ).filter(option => !allSitesUnsavedIds.has(option.id));
                        }

                        function getPendingSelectedOptions(keyword = null) {
                            const lowerKeyword = keyword ? keyword.toLowerCase() : null;

                            return ($scope.model.selectedItems || []).filter((option) => {
                                const isUnsaved = option.optionContainerStyle && option.optionContainerStyle.indexOf('unsaved') >= 0;
                                const isRemoved = allSitesUnsavedIds.has(option.id);
                                const matchesKeyword = !lowerKeyword || option.value.toLowerCase().indexOf(lowerKeyword) >= 0;

                                return isUnsaved && !isRemoved && matchesKeyword;
                            });
                        }

                        function loadSelectedSites(keyword = null) {
                            if (!$scope.model.selectedLink) {
                                return $q.resolve();
                            }

                            $scope.selectSitesModel.isLoading = true;
                            const requestVersion = invalidateSelectedSitesRequests();
                            const selectedSitesFilter = createSelectedSitesFilter(keyword);
                            const cacheKey = $scope.model.selectedLink + JSON.stringify(selectedSitesFilter);

                            if (!keyword) {
                                if (!requestsCache[cacheKey]) {
                                    requestsCache[cacheKey] = apiClient.get($scope.model.selectedLink, selectedSitesFilter);
                                }

                                return requestsCache[cacheKey]
                                    .then((response) => {
                                        if (!isSelectedSitesRequestCurrent(requestVersion)) {
                                            return response;
                                        }

                                        requestsCache[cacheKey] = $q.resolve(response);
                                        return processSelectedSitesResponse(response);
                                    })
                                    .catch((error) => {
                                        delete requestsCache[cacheKey];
                                        throw error;
                                    })
                                    .finally(() => {
                                        if (isSelectedSitesRequestCurrent(requestVersion)) {
                                            $scope.selectSitesModel.selected = [];
                                            $scope.selectSitesModel.isLoading = false;
                                        }
                                    });
                            }

                            return apiClient.get($scope.model.selectedLink, selectedSitesFilter)
                                .then((response) => {
                                    if (!isSelectedSitesRequestCurrent(requestVersion)) {
                                        return response;
                                    }

                                    return processSelectedSitesResponse(response);
                                })
                                .finally(() => {
                                    if (isSelectedSitesRequestCurrent(requestVersion)) {
                                        $scope.selectSitesModel.selected = [];
                                        $scope.selectSitesModel.isLoading = false;
                                    }
                                });
                        }

                        function advFilterPayload() {
                            const data = {};

                            advFilters?.name && (data.name = advFilters.name);
                            advFilters?.reference && (data.reference = advFilters.reference);
                            advFilters?.siteRegion && (data.regionSelect = { selected: advFilters.siteRegion });
                            advFilters?.sector && (data.sectorSelect = { selected: advFilters.sector });
                            advFilters?.siteGroup && (data.siteGroupSelect = { selected: advFilters.siteGroup });
                            advFilters?.coreClient && (data.coreClientSelect = { selected: advFilters.coreClient });

                            return data;
                        }

                        function updateSelectedOptions(data) {
                            deregisterUpdate && deregisterUpdate();

                            if ($scope.model.selectedLink) {
                                Object.keys(requestsCache).forEach((key) => {
                                    if (key.indexOf($scope.model.selectedLink) >= 0) {
                                        delete requestsCache[key];
                                    }
                                });
                            }

                            if ($scope.model.link) {
                                Object.keys(requestsCache).forEach((key) => {
                                    if (key.indexOf($scope.model.link) >= 0) {
                                        delete requestsCache[key];
                                    }
                                });
                            }

                            allSitesUnsavedIds = new Set();
                            pendingRemovedOptionsByHref = new Map();
                            $scope.model.isChanged = false;
                            $scope.model.selectedResponse = null;

                            const searchParams = Object.keys(advFilters).length ? advFilterPayload() : {};

                            if (isSelectedSitesPaginated()) {
                                // Reload from the API so pagination (load-more) is properly restored.
                                // Keep existing options visible (no blank flash) — processSelectedSitesResponse
                                // will replace them atomically once the fresh API response arrives.
                                $scope.selectSitesModel.isLoading = true;
                                $scope.model.selectedItems = [];
                                loadedSelectedSitesSaved = [];
                                allSitesSaved = angular.extend([], $scope.allSitesModel.options);
                                persistInternalState();

                                return loadSelectedSites().then(() => {
                                    return extendedSearchAction(searchParams).then(() => {
                                        registerUpdate();
                                        return $q.resolve();
                                    }).catch((error) => {
                                        registerUpdate();
                                        throw error;
                                    });
                                }).catch((error) => {
                                    registerUpdate();
                                    throw error;
                                });
                            }

                            // Non-paginated path: set options directly from the supplied data.
                            const cleanData = (data || []).map((option) => {
                                option.optionContainerStyle = (option.optionContainerStyle || '').replace('unsaved', '').trim();
                                return option;
                            });

                            $scope.selectSitesModel.options = filterSelectedOptions(cleanData);
                            $scope.model.selectedItems = $scope.selectSitesModel.options;

                            loadedSelectedSitesSaved = angular.extend([], $scope.selectSitesModel.options);
                            allSitesSaved = angular.extend([], $scope.allSitesModel.options);

                            persistInternalState();
                            $scope.selectedSitesFilteringKeyword && selectedSitesFilteringAction($scope.selectedSitesFilteringKeyword);

                            return extendedSearchAction(searchParams).then(() => {
                                registerUpdate();
                                return $q.resolve();
                            }).catch((error) => {
                                registerUpdate();
                                throw error;
                            });
                        }

                        function clearField(field) {
                            if (field === 'keyword') {
                                setKeyword('');
                            } else {
                                $scope.selectedSitesFilteringKeyword = '';
                                selectedSitesFilteringAction($scope.selectedSitesFilteringKeyword);
                            }
                        }

                        function createLoadNextFunction(response) {
                            if (!response) {
                                $scope.allSitesModel.hasMoreOptions = false;
                                return () => $q.resolve();
                            }

                            const page = response.page || 1;
                            const pages = response.pages || 1;
                            const hasNextLink = !!response.getLink('next');

                            $scope.allSitesModel.hasMoreOptions = (page < pages) && hasNextLink;

                            return function() {
                                const currentResponse = $scope.model.response;
                                if (!currentResponse) {
                                    return $q.resolve();
                                }

                                const currentPage = currentResponse.page || 1;
                                const totalPages = currentResponse.pages || 1;
                                const currentHasNextLink = !!currentResponse.getLink('next');

                                if (currentPage >= totalPages || !currentHasNextLink) {
                                    return $q.resolve();
                                }

                                const deferred = $q.defer();

                                return loadNextPage(currentResponse, deferred);
                            };
                        }

                        function loadNextPage(response, deferred) {
                            const nextLink = response.getLink('next');
                            if (!nextLink) {
                                $scope.allSitesModel.hasMoreOptions = false;
                                deferred.resolve();
                                return deferred.promise;
                            }

                            const nextPageCacheKey = nextLink;

                            let nextPagePromise;
                            if (requestsCache[nextPageCacheKey]) {
                                nextPagePromise = requestsCache[nextPageCacheKey];
                            } else {
                                nextPagePromise = apiClient.get(nextLink);
                                requestsCache[nextPageCacheKey] = nextPagePromise;
                            }

                            const processNextResponse = (nextResponse) => {
                                const newOptions = removeSelectedOptions(
                                    $scope.model.filterResponse(nextResponse),
                                    $scope.model.selectedItems
                                );

                                requestsCache[nextPageCacheKey] = nextResponse;

                                $scope.allSitesModel.options = [...$scope.allSitesModel.options, ...newOptions];

                                const hasNextLink = !!nextResponse.getLink('next');
                                $scope.allSitesModel.hasMoreOptions = (nextResponse.page < nextResponse.pages) && hasNextLink;
                                $scope.model.response = nextResponse;

                                deferred.resolve();
                            };

                            if (angular.isObject(nextPagePromise) && angular.isFunction(nextPagePromise.then)) {
                                nextPagePromise
                                    .then(processNextResponse)
                                    .catch(function(error) {
                                        console.error('Error loading more sites', error);
                                        $scope.allSitesModel.hasMoreOptions = false;
                                        delete requestsCache[nextPageCacheKey];
                                        deferred.reject(error);
                                    });
                            } else {
                                processNextResponse(nextPagePromise);
                            }

                            return deferred.promise;
                        }

                        function loadNextSelectedSitesPage() {
                            const response = $scope.model.selectedResponse;

                            if (!response) {
                                return $q.resolve();
                            }

                            const nextLink = response.getLink('next');

                            if (!nextLink) {
                                $scope.selectSitesModel.hasMoreOptions = false;
                                return $q.resolve();
                            }

                            const requestVersion = getSelectedSitesRequestVersion();

                            return apiClient.get(nextLink).then((nextResponse) => {
                                if (!isSelectedSitesRequestCurrent(requestVersion)) {
                                    return nextResponse;
                                }

                                processSelectedSitesResponse(nextResponse, true);
                            }).catch((error) => {
                                if (isSelectedSitesRequestCurrent(requestVersion)) {
                                    $scope.selectSitesModel.hasMoreOptions = false;
                                }

                                throw error;
                            });
                        }

                        initialLoadTimeout = $timeout(() => {
                            if ($scope.model.response) {
                                processApiResponse($scope.model.response);
                            } else if ($scope.model.link && Object.keys($scope.model.requestParams || {}).length) {
                                extendedSearchAction({});
                            }

                            if ($scope.model.selectedResponse) {
                                processSelectedSitesResponse($scope.model.selectedResponse);
                            } else if ($scope.model.selectedLink) {
                                loadSelectedSites();
                            }
                        });
                    }]
                };
            };
        });
})();
